// Device ID management utility
// Generates and retrieves a unique device ID from localStorage

/**
 * Get or generate a unique device ID for this computer/browser
 * @returns {string} The device ID
 */
export const getDeviceId = () => {
  const DEVICE_ID_KEY = 'sosoftpay_device_id';

  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    // Generate a unique device ID
    const timestamp = Date.now();
    const randomStr = Math.random().toString(36).substr(2, 9);
    deviceId = `device_${timestamp}_${randomStr}`;

    // Store as JSON string so react-clear-cache's use-persisted-state
    // doesn't crash when it tries to JSON.parse all storage events
    localStorage.setItem(DEVICE_ID_KEY, JSON.stringify(deviceId));
  } else {
    // Migration: if stored as raw string (legacy), re-store as JSON
    try {
      JSON.parse(deviceId);
    } catch (e) {
      localStorage.setItem(DEVICE_ID_KEY, JSON.stringify(deviceId));
    }
  }

  // Handle both JSON-stringified and raw legacy values
  try {
    return JSON.parse(deviceId);
  } catch (e) {
    return deviceId;
  }
};

/**
 * Get device information (for debugging/logging purposes)
 * @returns {object} Device information
 */
export const getDeviceInfo = () => {
  return {
    deviceId: getDeviceId(),
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
  };
};
